export default "__VITE_ASSET__pa5QN7wY__"